import type { APIMessage } from '@alternativamais/chat-core';
import { useRef, useState } from 'react';

import { avisarErro } from '../../../componentes/Avisos';
import { useAutoAltura } from '../../../componentes/useAutoAltura';
import { useCliente } from '../../../chat/contexto';
import { paraEdicao, paraEnvio } from '@alternativamais/chat-core';
import { useCanal } from './contexto';

/** Edição no lugar (C22): Enter salva, Esc cancela, vazio pergunta se apaga. */
export function Edicao({ mensagem }: { mensagem: APIMessage }) {
  const cliente = useCliente();
  const canal = useCanal();
  const [texto, setTexto] = useState(() => {
    const estado = cliente.store.getState();
    return paraEdicao(mensagem.content, {
      pessoa: (id) => estado.users[id]?.username ?? null,
      canal: (id) => estado.channels[id]?.name ?? null,
    });
  });
  const [salvando, setSalvando] = useState(false);
  const campo = useRef<HTMLTextAreaElement>(null);
  useAutoAltura(campo, texto);

  const salvar = async () => {
    const estado = cliente.store.getState();
    const guild = canal.guildId ? estado.guilds[canal.guildId] : null;
    const conteudo = paraEnvio(texto.trim(), {
      escolhidas: new Map(),
      pessoas: Object.values(estado.users),
      canais: canal.guildId
        ? (estado.guildChannelIds[canal.guildId] ?? [])
            .map((id) => estado.channels[id])
            .filter(Boolean)
        : [],
      emojis: guild?.emojis ?? [],
    });
    if (!conteudo) {
      canal.apagar(mensagem);
      return;
    }
    if (conteudo === mensagem.content) {
      canal.editar(null);
      return;
    }
    setSalvando(true);
    try {
      await cliente.editMessage(mensagem.channel_id, mensagem.id, conteudo);
      canal.editar(null);
    } catch (erro) {
      avisarErro(erro);
      setSalvando(false);
    }
  };

  return (
    <div className="flex flex-col gap-1.5 py-1">
      <div className="flex items-start gap-2 rounded-lg border border-destaque bg-campo p-2.5">
        <label className="sr-only" htmlFor={`editar-${mensagem.id}`}>
          Editar mensagem
        </label>
        <textarea
          id={`editar-${mensagem.id}`}
          ref={campo}
          autoFocus
          rows={1}
          value={texto}
          disabled={salvando}
          onFocus={(evento) => {
            const fim = evento.currentTarget.value.length;
            evento.currentTarget.setSelectionRange(fim, fim);
          }}
          onChange={(evento) => setTexto(evento.target.value)}
          onKeyDown={(evento) => {
            if (evento.key === 'Escape') {
              evento.preventDefault();
              canal.editar(null);
            } else if (
              evento.key === 'Enter' &&
              !evento.shiftKey &&
              !evento.nativeEvent.isComposing
            ) {
              evento.preventDefault();
              void salvar();
            }
          }}
          className="min-w-0 grow resize-none border-0 bg-transparent text-[15px] leading-[1.45] text-texto outline-none"
        />
      </div>
      <p className="m-0 text-xs text-texto-2">
        esc para{' '}
        <button
          type="button"
          onClick={() => canal.editar(null)}
          className="font-semibold text-link hover:underline"
        >
          cancelar
        </button>{' '}
        • enter para{' '}
        <button
          type="button"
          onClick={() => void salvar()}
          className="font-semibold text-link hover:underline"
        >
          salvar
        </button>
      </p>
    </div>
  );
}
